import { createAction, createAsyncAction } from "typesafe-actions";
import emailSchedulerDefinitionConstants from "store/features/emailScheduler/exceptions/exceptions.constants";
import { SchedulerExceptionForm } from "validation/components/EmailScheduler/exceptionsFormRules";

const {
    CREATE_SCHEDULER_RULE_EXCEPTION_REQUEST,
    CREATE_SCHEDULER_RULE_EXCEPTION_SUCCESS,
    CREATE_SCHEDULER_RULE_EXCEPTION_FAILED,
    FETCH_SCHEDULER_RULE_EXCEPTIONS_REQUEST,
    FETCH_SCHEDULER_RULE_EXCEPTIONS_SUCCESS,
    FETCH_SCHEDULER_RULE_EXCEPTIONS_FAILED,
    DELETE_SCHEDULER_EXCEPTION_REQUEST,
    DELETE_SCHEDULER_EXCEPTION_SUCCESS,
    DELETE_SCHEDULER_EXCEPTION_FAILED,
    UPDATE_SCHEDULER_EXCEPTION_REQUEST,
    UPDATE_SCHEDULER_EXCEPTION_SUCCESS,
    UPDATE_SCHEDULER_EXCEPTION_FAILED,
    TOGGLE_EDIT,
    CANCEL_EXCEPTION_UPDATE,
} = emailSchedulerDefinitionConstants;

export const createSchedulerRuleException = createAsyncAction(
    CREATE_SCHEDULER_RULE_EXCEPTION_REQUEST,
    CREATE_SCHEDULER_RULE_EXCEPTION_SUCCESS,
    CREATE_SCHEDULER_RULE_EXCEPTION_FAILED
)<SchedulerExceptionForm, void, ErrorHandler>();

export const updateSchedulerRuleException = createAsyncAction(
    UPDATE_SCHEDULER_EXCEPTION_REQUEST,
    UPDATE_SCHEDULER_EXCEPTION_SUCCESS,
    UPDATE_SCHEDULER_EXCEPTION_FAILED
)<SchedulerExceptionForm, void, ErrorHandler>();

export const fetchSchedulerRuleExceptions = createAsyncAction(
    FETCH_SCHEDULER_RULE_EXCEPTIONS_REQUEST,
    FETCH_SCHEDULER_RULE_EXCEPTIONS_SUCCESS,
    FETCH_SCHEDULER_RULE_EXCEPTIONS_FAILED
)<void, { exceptions: SchedulerExceptionForm[] }, ErrorHandler>();

export const deleteSchedulerRuleException = createAsyncAction(
    DELETE_SCHEDULER_EXCEPTION_REQUEST,
    DELETE_SCHEDULER_EXCEPTION_SUCCESS,
    DELETE_SCHEDULER_EXCEPTION_FAILED
)<{ id: string }, void, ErrorHandler>();

export const editExceptionRule = createAction(TOGGLE_EDIT, (id: string) => {
    return id;
})();

export const cancelExceptionUpdate = createAction(CANCEL_EXCEPTION_UPDATE)();
